import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1"
      aria-label={`查看${movie.title}详情`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} - ${movie.genres.join('、')}影视作品封面`}
          title={`${movie.title} 大雷影视详情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/10 to-transparent" />

        {typeof rank === 'number' && (
          <span className="absolute left-0 top-0 flex h-8 w-8 items-center justify-center rounded-br-lg bg-accent-500 font-label text-lg font-semibold leading-none text-background-50">
            {rank}
          </span>
        )}

        <span className="absolute right-2 top-2 rounded-md bg-primary-950/70 px-1.5 py-0.5 font-label text-xs font-semibold tracking-wide text-accent-300 backdrop-blur-sm">
          {movie.category === 'movie' ? '电影' : '剧集'}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="mb-1 flex items-center gap-1.5">
            <i className="ri-star-fill text-[11px] text-accent-400" />
            <span className="font-label text-sm font-semibold text-background-50">{movie.rating.toFixed(1)}</span>
            <span className="text-[11px] text-background-200/80">{movie.duration}</span>
          </div>
          <p className="truncate text-[11px] text-background-100/85">
            {movie.year} · {movie.region}
          </p>
        </div>

        <div className="absolute inset-0 flex flex-col justify-end bg-primary-950/92 p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100 max-md:hidden">
          <p className="mb-2 text-[11px] font-medium uppercase tracking-widest text-accent-400">
            {movie.genres.join(' / ')}
          </p>
          <p className="line-clamp-5 text-xs leading-relaxed text-background-100">{movie.summary}</p>
          <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
            查看详情
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-0.5 truncate text-xs text-foreground-500">
          {movie.genres.slice(0, 2).join(' · ')} · {movie.region}
        </p>
      </div>
    </Link>
  );
}